import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import {
  BiContextProvidedValue,
  BiData,
  AddToGroupSelectBiEvent,
} from '@wix/da-bi/pkg/events';
import ArrowRight from '@wix/da-ds/pkg/Icons/ArrowRight';
import { ListItemButton } from '@wix/da-ds/pkg/List/ListItem';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import StreamedList from '../../../StreamedList';
import BasicUserAvatar from '../../../User/_partials/BasicUserAvatar';
import RecommendedGroupList from './RecommendedGroupList';
import s from './GroupsList.scss';

export interface Props {
  headerContent?: React.ReactNode;
  deviationId: number;
  streamId: string;
  groups: PapiUser[];
  isFetching: boolean;
  filterValue?: string;
  scrollableWrapperClassName?: string;
  onSelect: (group: PapiUser) => void;
}

const GroupsList: React.FC<Props> = ({
  headerContent,
  groups,
  onSelect,
  isFetching,
  deviationId,
  streamId,
  filterValue,
}) => {
  const isEmpty = !isFetching && groups.length === 0;

  if (isEmpty) {
    return (
      <>
        {headerContent}
        <RecommendedGroupList
          deviationId={deviationId}
          filterValue={filterValue}
          onSelect={onSelect}
        />
      </>
    );
  }

  if (isFetching && !groups.length) {
    return <LoadingIndicator view="llama" className={s['loader']} />;
  }

  return (
    <>
      {headerContent}
      <StreamedList
        streamId={streamId}
        className={s['list']}
        wrapperClassName={s['scrollable']}
      >
        {groups.map(group =>
          !filterValue ||
          group.username.toLowerCase().includes(filterValue.toLowerCase()) ? (
            <ListItemButton
              key={group.userId}
              onClick={() => onSelect(group)}
              biData={BiData<AddToGroupSelectBiEvent>({
                evid: 341,
                deviationid: deviationId,
                groupid: group.useridUuid,
                source_type: BiContextProvidedValue,
              })}
              label={group.username}
              prefix={<BasicUserAvatar user={group} size={35} />}
              suffixIcon={ArrowRight}
              fillContainerWidth
              showSuffixOnlyOnHover
            />
          ) : null
        )}
      </StreamedList>
    </>
  );
};
GroupsList.displayName = 'GroupsList';

export default GroupsList;
